import { QrCode, AlertTriangle } from "lucide-react";
import { Alert, AlertDescription } from "@/components/ui/alert";

interface EscaparateBannerProps {
  variant?: "header" | "checkout";
}

const EscaparateBanner = ({ variant = "header" }: EscaparateBannerProps) => {
  if (variant === "checkout") {
    return (
      <Alert className="border-amber-500 bg-amber-50 mb-6">
        <AlertTriangle className="h-5 w-5 text-amber-600" />
        <AlertDescription className="text-amber-800 font-medium ml-2">
          <strong>Modo Escaparate:</strong> Para realizar un pedido, debes escanear el código QR de tu mesa o mostrador en el local.
        </AlertDescription>
      </Alert>
    );
  }

  return (
    <div className="bg-amber-100 border-b border-amber-200 py-3 px-4">
      <div className="container mx-auto flex items-center justify-center gap-2 text-amber-800 text-sm md:text-base">
        <QrCode className="h-5 w-5 flex-shrink-0" />
        <span className="font-medium text-center">
          Estás viendo la carta digital. Para pedir, escanea el código QR de tu mesa o mostrador.
        </span>
      </div>
    </div>
  );
};

export default EscaparateBanner;
